import { render, staticRenderFns } from "./ViewRecords.vue?vue&type=template&id=77a39812&scoped=true"
import script from "./ViewRecords.vue?vue&type=script&lang=js"
export * from "./ViewRecords.vue?vue&type=script&lang=js"
import style0 from "./ViewRecords.vue?vue&type=style&index=0&id=77a39812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a39812",
  null
  
)

export default component.exports